import { Button } from '@presentation/components';
import type { FC } from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { useTranslation } from '@presentation/utils';

import type { WhatsappButtonProps } from './types';

export * from './types';

export const WhatsappButton: FC<WhatsappButtonProps> = (props) => {
  const { translate } = useTranslation();

  const {
    onClick,
    size = 'large',
    color = 'whatsappGreen',
    shrink = false,
    shadow = false,
    outlined = true,
    label = translate('common.buttons.whatsApp'),
    ...rest
  } = props;

  return (
    <Button
      onClick={onClick}
      color={color}
      size={size}
      iconLeft={<FaWhatsapp size={20} />}
      shadow={shadow}
      outlined={outlined}
      shrink={shrink}
      {...rest}
    >
      {label}
    </Button>
  );
};
